import {
    Box,
    Drawer,
    Grid,
    IconButton,
    Stack,
    Divider,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import React from "react";

import { SystemUserTypes } from "../../types";
import { Label } from "../label";

interface Props {
    visible: boolean,
    onClose(): void,
    admin: SystemUserTypes.Model,
};

export const AdminDetailsDrawer: React.FC<Props> = ({
    visible,
    admin,
    onClose,
}) => {
    return (
        <Drawer
            anchor='bottom'
            open={visible}
            onClose={onClose}
        >
            <Stack

                direction={'column'}
                justifyContent={'space-between'}
                style={{
                    backgroundColor: '#FFF'
                }}
            >
                <Box>

                    <Stack direction={'row'} justifyContent={'space-between'} mt={1} style={{ padding: 10 }}>
                        <Typography fontWeight={400} textAlign={'left'}>
                            System User Details
                        </Typography>
                        <IconButton
                            onClick={onClose}
                            sx={{ alignSelf: 'flex-start' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>

                    <Divider />

                    <Box style={{ padding: 16 }} mt={1}>
                        <Grid container spacing={2}>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Full Name
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.fullname}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Email
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.email}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500} mb={1}>
                                    Status
                                </Typography>
                                {
                                    !admin?.active ?
                                        <Label
                                            variant={'ghost'}
                                            color={'error'}
                                        >
                                            Deactivated
                                        </Label> :
                                        <Label
                                            variant={'ghost'}
                                            color={'success'}
                                        >
                                            Activated
                                        </Label>
                                }
                            </Grid>

                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Created At
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.createdAt ? dayjs(admin?.createdAt).format('MM/DD/YYYY hh:mm A') : '----'}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Last Update
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.updatedAt ? dayjs(admin?.updatedAt).format('MM/DD/YYYY hh:mm A') : '----'}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Last Login
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.lastActive ? dayjs(admin?.lastActive).format('MM/DD/YYYY hh:mm A') : '----'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider />

                    <Box style={{ padding: 10 }} mt={1}>
                        <Typography fontWeight={500} mb={3}>
                            Alert Settings
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Email
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.alertSettings?.email ? 'Activated' : 'Deactivated'}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Phone SMS
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.alertSettings?.sms ? 'Activated' : 'Deactivated'}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Phone Call
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.alertSettings?.call ? 'Activated' : 'Deactivated'}
                                </Typography>
                            </Grid>
                            <Grid item md={6} sm={12}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Dashboard Push Notification
                                </Typography>
                                <Typography fontSize={14} fontWeight={400} mt={1}>
                                    {admin?.alertSettings?.push ? 'Activated' : 'Deactivated'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>


                </Box>
            </Stack>

        </Drawer>
    )
}